export const LD_QA_FLAG = 'qa';
export const LD_TASK_LIST_V2_TEMPLATE_EDITOR_FLAG =
  'task-list-v2-template-editor';
export const LD_ASYNC_TODOS_CREATE_FLAG = 'async-todo-list-create';
export const LD_SIGNUP_EMAIL_VALIDATION = 'signup-email-validation';
export const LD_PROJECT_TRASH_CAN_FLAG = 'project-trash-can';
export const LD_CASH_REFERRAL_FLAG = 'cash-referral-program';
export const LD_DOCUMENT_SIGNING = 'document-signing';
export const LD_COLLAB_REMOVE_PERMS_FLAG = 'collab-remove-perms';
export const LD_INTERCOM_HELP_CENTER_AND_MESSENGER_FLAG =
  'intercom-help-center-and-messenger';
export const LD_SIGN_UP_REQUIRE_HOW_HEARD_DETAIL_FLAG =
  'require-how-heard-detail-on-signup-form';
export const LD_SIGN_UP_REQUIRE_COMPANY_SIZE_FLAG =
  'display-company-size-field-on-signup-form';
export const LD_PROJECT_BLUEPRINTS_RENAME = 'project-blueprints-rename';
export const LD_PROJECT_MENU_GOOGLE_CALENDAR_OPTION_FLAG =
  'project-menu-google-calendar-option';
export const LD_WORKFLOWS_SKIP_CHECKLIST_SECTIONS =
  'workflows-skip-checklist-sections';
export const LD_COMPARE_PLANS_PAGE = 'compare-plans-page';
export const LD_PROJECT_COLLAPSIBLE_SIDEBAR = 'project-collapsible-sidebar';
export const LD_ORGANIZATION_METRICS = 'organization-metrics';
export const LD_INTEGRATIONS_NEW_QBO_MODAL =
  'send-photos-to-quickbooks-records';
export const LD_WORKFLOWS_EXPIRING_SHARED_URLS =
  'workflows-expiring-shared-url';
export const LD_WORKFLOWS_REST_PROJECT_TASKS =
  'workflows-web-project-task-rest';
export const LD_EXPORT_PAGE_PDF_FLAG = 'export-page-pdf';
export const LD_WORKFLOWS_SWITCH_VIEW_REPORT_BUTTON =
  'workflows-switch-view-report-button';
export const LD_WORKFLOWS_ASSIGN_PROJECT_TASK =
  'workflows-assign-project-tasks';
export const LD_SECURE_UPLOADS_REQUESTS_WEB_FLAG =
  'secure-uploads-requests-web';
export const LD_MAP_PROJECT_CARDS = 'map-project-cards';
export const LD_REVIEWS_BETA_FLAG = 'reviews-beta';
export const LD_YEAR_IN_REVIEW = 'year-in-review-2024';
export const LD_YEAR_IN_REVIEW_PUBLIC = 'year-in-review-2024-public';
export const LD_DEFAULT_SAVE_TO_PROJECT_DOCUMENTS_ON =
  'save-to-project-documents-defaults-to-on';
export const LD_UPDATED_TOS_PRIVACY_INFO =
  'updated-terms-of-service-privacy-info';
export const LD_DYNAMIC_TRANSLATION = 'dynamic-translation';
export const LD_IMPROVE_PROJECT_TEMPLATE_DISCOVERABILITY =
  'improve-project-template-discoverability';
export const LD_CHECKLIST_TEMPLATE_EXPORT = 'checklist-template-export';
export const LD_MARKETING_HUB_FLAG = 'marketing-hub';
export const LD_TEMPLATES_MODAL_REDESIGN = 'templates-modal-redesign';
export const LD_SET_A_REMINDER_FLAG = 'set-a-reminder';
export const LD_SEMANTIC_PHOTO_SEARCH_TEST = 'semantic-photo-search-test';
export const LD_PAYMENTS_ONBOARDING_REWORK_FLAG = 'payments-onboarding-rework';
export const LD_REVIEW_REQUESTS_FLAG = 'review-requests';
export const LD_SAVE_PAGE_TO_DOCUMENTS = 'outputs-save-page-to-documents';
export const LD_WEB_VIDEO_MULTIPART_UPLOAD = 'web-video-multipart-upload';
export const LD_MARKETING_NAV_MENU = 'marketing-nav-menu';
